import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationStratalotTodoProfilApiService } from './organization-stratalot-todo-profil-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationStratalotTodoProfilApiService extends GeneratedOrganizationStratalotTodoProfilApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
